module.exports = __webpack_public_path__ + "static/media/icon-O2O-system6.185e7728.png";